import React, { useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { moduleContext } from 'react-contextual'
import { walletApiEvents, walletApiSelectors } from 'modules/api/wallet'
import { accountingApiEvents } from 'modules/api/accounting'
import { contactsEvents, contactsSelectors } from 'modules/contacts/state'
import { path } from 'ramda'
import { $TSFixMe } from 'types/ts-migrate'
interface DepositAccountProviderProps {
  partyId: string
  accountId: string
  accountType: string
}

const DepositAccountProvider = moduleContext()(
  ({
    context,
    children,
    partyId,
    accountId,
    accountType,
  }: DepositAccountProviderProps & { context: any; children: React.ReactNode }) => {
    const store = useStore()
    const dispatch = useDispatch()
    const state = store.getState()
    const getWalletAsset = (partyId: any, accountId: any, accountType: string) =>
      walletApiSelectors.getBalanceAsset(state)(partyId, accountId, accountType)

    const depositAccountBalance = walletApiSelectors.getDepositAccountBalance(state)(partyId, accountId)

    useEffect(() => {
      dispatch(walletApiEvents.balance_request({ partyId }))
      dispatch(accountingApiEvents.depositStatementJson_request({ id: partyId, accountId }))
    }, [partyId, accountId, dispatch])

    const depositStore = {
      depositAccountBalance,
      getWalletAsset,
      depositTransferModal: useSelector(contactsSelectors.depositTransferModal),
      openDepositTransferModal: () => {
        const selectedPartyAccountAsset = path(['name'], getWalletAsset(partyId, accountId, accountType))
        if (selectedPartyAccountAsset) {
          dispatch(
            contactsEvents.openDepositTransferModal({
              partyId,
              account: accountId,
              asset: selectedPartyAccountAsset,
            }),
          )
        }
      },
      handleTransfer: ({ body, params }: any) => {
        dispatch(
          walletApiEvents.transfer_request({
            body,
            params,
            meta: {
              partyId,
              amount: body.amount,
              account: body.account,
            },
          }),
        )
      },
      closeDepositTransferModal: () => dispatch(contactsEvents.closeDepositTransferModal()),

      // Deposit Top Up Request
      openDepositTopupRequest: (partyId: $TSFixMe, portfolioId: $TSFixMe) =>
        dispatch(contactsEvents.depositTopupRequestOpened({ partyId, portfolioId })),
      // ...props,
    }

    return <context.Provider value={depositStore}>{children}</context.Provider>
  },
)

export default DepositAccountProvider
